import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './../src/global.css'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <BubblyContainer>  */}
      
      <App />
      
      {/* </BubblyContainer > */}
    </BrowserRouter>

  </React.StrictMode>
);
